/*
ヘッダーや検索バーの位置を variant や current_ui で管理するのではなく、
.sticky-top を上から走査して高さを動的に変えていく。
.sticky-top は Bootstrap 依存のCSSクラス名なので注意。
*/

document.addEventListener('turbolinks:load', () => {
  const $ = (window as any).jQuery;

  let stickyElementsHeight = 0;
  $('.sticky-top').each((i: number, element: Element) => {
    $(element).css('top', stickyElementsHeight);
    stickyElementsHeight += $(element).outerHeight();
  });

});
